var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.moduleConfig.carrier_invoice_page ? _vm.moduleConfig.carrier_invoice_page.form_title : '輸入發票載具與發票') + " ")]), _vm.moduleConfig.carrier_invoice_page ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.moduleConfig.carrier_invoice_page && _vm.moduleConfig.carrier_invoice_page.form_desc))]) : _vm._e(), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("手機/載具條碼")]), _c('div', {
    staticClass: "d-flex align-items-center s-space-x-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.card_no,
      expression: "card_no"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.card_no.$error
    },
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": _vm.card_no
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.card_no = $event.target.value;
      }
    }
  })]), _c('small', {
    staticClass: "field__desc"
  }, [_vm._v("範例：/AB-82CQ")]), _vm.v$.card_no.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 手機/載具條碼有誤或未填寫，請確認 ")]) : _vm._e()]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("手機/載具驗證碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.card_encrypt,
      expression: "card_encrypt"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.card_encrypt.$error
    },
    attrs: {
      "type": "password",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.card_encrypt
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.card_encrypt = $event.target.value;
      }
    }
  }), _vm.v$.card_encrypt.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 手機/載具驗證碼有誤或未填寫，請確認 ")]) : _vm._e()]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("手機/載具驗類型")]), _c('SharedSelect', {
    class: {
      invalid: _vm.v$.card_type.$error
    },
    attrs: {
      "options": _vm.card_type_options
    },
    model: {
      value: _vm.card_type,
      callback: function callback($$v) {
        _vm.card_type = $$v;
      },
      expression: "card_type"
    }
  }), _vm.v$.card_type.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 資料有誤或未選擇，請確認 ")]) : _vm._e()], 1), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("發票號碼")]), _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-4 align-self-start"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.alphabetic_letter,
      expression: "alphabetic_letter"
    }],
    staticClass: "field__input uppercase",
    class: {
      invalid: _vm.v$.alphabetic_letter.$error
    },
    attrs: {
      "placeholder": "發票字軌",
      "maxlength": "2"
    },
    domProps: {
      "value": _vm.alphabetic_letter
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.alphabetic_letter = $event.target.value;
      }
    }
  }), _vm.v$.alphabetic_letter.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 請輸入正確發票字軌 ")]) : _vm._e()]), _c('span', {
    staticClass: "col-1 text-center align-self-start"
  }, [_vm._v("-")]), _c('div', {
    staticClass: "col-7 align-self-start"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.number,
      expression: "number"
    }],
    staticClass: "field__input",
    class: {
      invalid: _vm.v$.number.$error
    },
    attrs: {
      "placeholder": "請輸入發票號碼",
      "maxlength": "8"
    },
    domProps: {
      "value": _vm.number
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value;
      }
    }
  }), _vm.v$.number.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 請輸入正確發票號碼 ")]) : _vm._e()])]), _c('small', {
    staticClass: "field__desc"
  }, [_vm._v("須包含英文，例：SH-87654321")])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label",
    class: 'field--required'
  }, [_vm._v("開立日期")]), _c('datepicker', {
    staticClass: "field__input py-0",
    class: {
      invalid: _vm.v$.invoice_at.$error
    },
    attrs: {
      "placeholder": "請輸入開立日期",
      "bootstrap-styling": "",
      "format": "yyyy/MM/dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.invoice_at,
      callback: function callback($$v) {
        _vm.invoice_at = $$v;
      },
      expression: "invoice_at"
    }
  }), _vm.v$.invoice_at.$error ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 請輸入開立日期 ")]) : _vm._e()], 1), _vm._l(_vm.terms, function (term, index) {
    return _c('div', {
      key: index,
      staticClass: "field",
      class: index == 0 ? 's-mb-8' : ''
    }, [_c('Accordion', {
      attrs: {
        "title": term.title
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(term.content)
      }
    })]), _c('Checkbox', {
      attrs: {
        "name": 'checkbox' + index
      },
      model: {
        value: _vm.checked[index],
        callback: function callback($$v) {
          _vm.$set(_vm.checked, index, $$v);
        },
        expression: "checked[index]"
      }
    }, [_vm._v("已詳閱使用須知並同意相關使用說明")])], 1);
  })], 2)]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": !_vm.isAllChecked
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("送出")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }